import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getMetrics, getError, getIsFetching } from 'store/selectors/metrics';
import { getCategories } from 'store/selectors/categories';
import {
  getMetricsFromServer,
  setMetricsDuration,
} from 'store/actions/metrics';
import { getCategoriesFromServer } from 'store/actions/categories';
import Perf from './Perf';

const selector = createStructuredSelector({
  error: getError,
  metrics: getMetrics,
  isFetchingMetrics: getIsFetching,
  categories: getCategories,
});

const actions = {
  getMetrics: getMetricsFromServer,
  setDuration: setMetricsDuration,
  onGetCategories: getCategoriesFromServer,
};

export default connect(
  selector,
  actions,
)(Perf);
